var DeskStateService = (function () {
    function DeskStateService() {
        this.stateKey = 'stopDeskState';
    }
    DeskStateService.prototype.saveState = function (state) {
        localStorage.setItem(this.stateKey, JSON.stringify(state));
    };
    DeskStateService.prototype.loadState = function () {
        var savedState = localStorage.getItem(this.stateKey);
        return savedState ? JSON.parse(savedState) : null;
    };
    DeskStateService.prototype.clearState = function () {
        localStorage.removeItem(this.stateKey);
    };
    return DeskStateService;
}());
export { DeskStateService };
